import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { AuthPage } from './AuthPage';
import { OnboardingPage } from './OnboardingPage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const [hasShownOnboarding, setHasShownOnboarding] = useState(false);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <AuthPage />;
  }

  // Show onboarding if user doesn't have API key and hasn't seen onboarding yet
  if (!user.has_api_key && !hasShownOnboarding) {
    return <OnboardingPage onComplete={() => {
      setHasShownOnboarding(true);
      // If they added an API key, refresh to update user context
      if (user.has_api_key) {
        window.location.reload();
      }
    }} />;
  }

  return <>{children}</>;
}